import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { Pageable, ResponseData } from "services/common"

export interface CheckInRow {
  check_in_date: number
  pmc_name: string
  health_score: number | null
  risks: string
  booking_id: string
  traveler_name: string
  booking_value: number
  pmc_id: string
}

export interface CheckInsStatCards {
  total_checkins: number
  total_booking_risks: number
  total_no_comms_count: number
  total_low_pmc_health_count: number
}

interface CheckInsPage extends Pageable {
  content: CheckInRow[]
}

interface GetCheckInsResponseData extends ResponseData {
  data: {
    checkins_data: CheckInsPage
    stat_cards: CheckInsStatCards
  }
}

interface GetCheckInsResponse extends AxiosResponse {
  data: GetCheckInsResponseData
}

export interface GetCheckInsRequest extends Partial<AxiosRequestConfig> {
  params: {
    startDt: string
    endDt: string
    pmcId: string
    noCommunication?: boolean
    lowPMCHealth?: boolean
    noRisk?: boolean
    pageNo: number
    noOfRecords: number
  }
}

export function getCheckInsApi(
  { params, ...config }: GetCheckInsRequest,
  axiosInstance: AxiosInstance,
): Promise<GetCheckInsResponse> {
  return axiosInstance({
    method: "get",
    params,
    url: `newadmin/check-ins`,
    ...config,
  })
}
